// hooks/useQrValue.js or useQrValue.ts
import { useEffect, useState } from 'react';
import { appDownloadLink } from '@helpers/constants';
import { getCookie } from '@helpers/url-utm-handler';

const useQrValue = () => {
    const [qrValue, setQrValue] = useState('');

    useEffect(() => {
        const visitUrlCookie = getCookie('visit_url') || {};
        const updatedURL = appDownloadLink.replace(
            '{deep_link_sub1}',
            encodeURIComponent(visitUrlCookie)
        );
        setQrValue(updatedURL.toString());
    }, []);

    return qrValue;
};

export default useQrValue;
